import { Component, input } from '@angular/core';
import { MatCardModule } from '@angular/material/card';

import { UiChartSeriesPoint } from './ui-chart.types';

@Component({
  selector: 'ui-chart',
  standalone: true,
  imports: [MatCardModule],
  templateUrl: './ui-chart.component.html'
})
export class UiChartComponent {
  readonly title = input('');
  readonly series = input<UiChartSeriesPoint[]>([]);
}
